
import { Accordion, AccordionDetails, AccordionSummary, Box, ImageListItem, Link, Typography } from '@mui/material';
import { useContext } from 'react';
import ExpandMoreIcon from 'remixicon-react/ArrowDownSFillIcon';
import LinkIcon from 'remixicon-react/LinksFillIcon';
import EmailIcon from 'remixicon-react/MailFillIcon';
import PhoneIcon from 'remixicon-react/SmartphoneFillIcon';
import { ConfigContext } from '../../../../App/App';
import { CatalogCard } from '../../../../Shared/API/ApiTypes';
import './Card.css';

function Card(props: { card: CatalogCard, itemNumber: number }) {
  const config = useContext(ConfigContext);
  const maxCharacters = 249;
  // const programDetails = props.card.programDetails.substring(0, maxCharacters) + "...";
  return (
    <Accordion sx={{ overflow: 'hidden' }}>
      <AccordionSummary sx={{ pl: 1, overflow: 'hidden', '& .MuiAccordionSummary-content': { overflow: 'hidden', my: 1 } }}
        expandIcon={<ExpandMoreIcon size="1rem" />}>
        <Box sx={{ display: 'flex', maxWidth: '100%' }}>
          <Box sx={{ pt: 1, pr: 1, flex: '0 0 25%', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRight: '1px solid #e8e8e8' }}>
            <ImageListItem sx={{ width: '100%', height: '100%' }}>
              <img
                src={props.card.colorLogo}
                alt={props.card.collegeName}
                loading="lazy"
              /></ImageListItem>

            <Box >
              <Link href={props.card.applyUrl} target="_blank" sx={{ color: config.SecondaryColor, fontWeight: 'bold', textDecoration: 'none', fontSize: '.75rem' }} rel="noopener noreferrer">Apply Now</Link>
            </Box>
          </Box>
          <Box sx={{ pl: 1, flex: '0 0 75%', overflow: 'hidden', lineHeight: '1' }}>
            <div>
              <Typography variant="caption">{props.card.collegeName}</Typography>
            </div>
            {props.card.programs.map((program, index) => {
              return (
                <div key={index} >
                  <Typography variant="caption" sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: 'hidden', fontWeight: 'bold', lineHeight: '1' }}>{program.program}</Typography>
                </div>
              )
            })}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ flex: '0 0 100%', display: 'flex', alignItems: 'flex-start', flexDirection: 'column', textAlign: 'left', justifyContent: 'space-around' }}>
          {props.card.programs.map((program, index) => {
            return (
              <Box sx={{ mb: 3 }} key={index}>
                <Box >
                  <Typography variant="body1" >{program.program}</Typography>
                </Box>
                <Box>
                  <Typography variant="body2" >{program.term}</Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Typography sx={{ fontWeight: 'bold' }} variant="body2" >{program.deliveryMethod}</Typography>
                </Box>
                <div>
                  <Typography sx={{ my: 1 }} variant="caption" >{program.programDetails.substring(0, maxCharacters) + "..."} </Typography>
                </div>
              </Box>
            )
          })}
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', width: '100%' }}>
            <Box sx={{ flex: '0 0 100%' }}>
              <div>
                <Typography sx={{ fontWeight: 'bold', color: config.SecondaryColor, my: 1 }} variant="body2" >Contact Admissions</Typography>
              </div>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: 1 }}>
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: '4px' }} variant="caption"><PhoneIcon size="1rem" />{props.card.admissionsPhone}</Typography>
              </Box>
              <Box >
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: 1 }} variant="caption"><EmailIcon size="1rem" />{props.card.admissionsEmail}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: 1 }}>
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: '4px' }} variant="caption"><LinkIcon size="1rem" />{props.card.admissionsUrl}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
export default Card;